import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
    Box,
    Button,
    Container,
    Paper,
    TextField,
    Typography,
    MenuItem,
    CircularProgress,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../../Navbar/Navbar";
import baseURL from "../../config";
import BgImage from "../../assets/shipimage.jpg";

const AdminSignup = () => {
    const navigate = useNavigate();

    const [adminUser, setAdminUser] = useState({
        userType: "",
        username: "",
        email: "",
        password: "",
        confirmpassword: "",
    });

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const inputHandler = (e) => {
        const { name, value } = e.target;
        setAdminUser({ ...adminUser, [name]: value });

        if (name === "password" || name === "confirmpassword") {
            if (adminUser.password === adminUser.confirmpassword) {
                setError("");
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        const { password, confirmpassword, userType, email, username } = adminUser;

        if (password !== confirmpassword) {
            setError("Passwords do not match");
            return;
        }

        if (!userType) {
            setError("Please select a userType");
            return;
        }

        try {
            setLoading(true);

            const { data } = await axios.post(`${baseURL}/api/check-email`, { email });
            if (data.exists) {
                toast.error("Email already exists!");
                setLoading(false);
                return;
            }

            await axios.post(`${baseURL}/api/signup`, { userType, username, email, password });

            localStorage.setItem("userEmail", email); // Store email in localStorage
            localStorage.setItem("userName", username); // Store name in localStorage

            toast.success("Signup successful! Redirecting...");
            setTimeout(() => navigate("/otp"), 1000);
        } catch (err) {
            setError("An error occurred during signup");
            toast.error("Signup failed! Try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Navbar />
            <Box
                sx={{
                    width: "100%",
                    height: "100vh",
                    backgroundImage: `url(${BgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    overflow: "hidden", // Prevents scrollbars
                }}
            >
                <Container maxWidth="xs">
                    <Paper
                        elevation={10}
                        sx={{
                            p: 3,
                            borderRadius: 3,
                            bgcolor: "rgba(255, 255, 255, 0.9)",
                            height: "auto", // Adjust height dynamically
                            maxHeight: "500px", // Restrict max height
                            overflow: "hidden",
                        }}
                    >
                        <Typography variant="h5" fontWeight="bold" mb={2}>
                            Admin Signup
                        </Typography>
                        <form onSubmit={handleSubmit}>
                            <TextField
                                select
                                fullWidth
                                label="userType"
                                name="userType"
                                value={adminUser.userType}
                                onChange={inputHandler}
                                required
                                margin="dense"
                            >
                                <MenuItem value="">Select userType</MenuItem>
                                <MenuItem value="team_leader">Team Leader</MenuItem>
                                <MenuItem value="BSE">BSE</MenuItem>
                                {/* <MenuItem value="admin">Admin</MenuItem> */}
                            </TextField>
                            <TextField fullWidth label="Username" name="username" value={adminUser.username} onChange={inputHandler} required margin="dense" />
                            <TextField fullWidth label="Email" name="email" type="email" value={adminUser.email} onChange={inputHandler} required margin="dense" />
                            <TextField fullWidth label="Password" name="password" type="password" value={adminUser.password} onChange={inputHandler} required margin="dense" />
                            <TextField fullWidth label="Confirm Password" name="confirmpassword" type="password" value={adminUser.confirmpassword} onChange={inputHandler} required margin="dense" />

                            {error && <Typography color="error" mt={1}>{error}</Typography>}

                            <Button variant="contained"  fullWidth sx={{ mt: 2, p: 1, borderRadius: 2 , backgroundColor:"#C30B12"}} type="submit" disabled={loading}>
                                {loading ? <CircularProgress size={24} /> : "Sign Up"}
                            </Button>
                        </form>
                        <ToastContainer position="top-right" autoClose={5000} />
                    </Paper>
                </Container>
            </Box>
        </>
    );
};

export default AdminSignup;
